import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import users from '../../locales/en/users';
import projects from '../../locales/en/projects';
import config from '../../locales/en/config';
import ui from '../../locales/en/ui';
import shared from '../../locales/en/shared';
import templates from '../../locales/en/templates';
import workspaces from '../../locales/en/workspaces';
import prototypes from '../../locales/en/prototypes';
import admin from '../../locales/en/admin';
import appraisals from '../../locales/en/appraisals';
import payments from '../../locales/en/payments';
import teams from '../../locales/en/teams';
import auth from '../../locales/en/auth';
import reports from '../../locales/en/reports';
import websites from '../../locales/en/websites';
import personas from '../../locales/en/personas';
import { I18nResources } from '../types';

export const allNS = [
  'projects',
  'users',
  'config',
  'shared',
  'ui',
  'templates',
  'workspaces',
  'prototypes',
  'admin',
  'appraisals',
  'payments',
  'teams',
  'auth',
  'reports',
  'websites',
  'personas',
] as const;

export const defaultNS = 'actions';
export const resources = {
  en: {
    projects,
    users,
    config,
    shared,
    ui,
    templates,
    workspaces,
    prototypes,
    admin,
    appraisals,
    payments,
    teams,
    auth,
    reports,
    websites,
    personas,
  },
};

i18next.use(initReactI18next).init({
  lng: 'en',
  ns: allNS,
  defaultNS,
  resources,
});

declare module 'i18next' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface CustomTypeOptions {
    defaultNS: typeof defaultNS;
    resources: (typeof resources)['en'];
    contextSeparator: '-';
  }
}

const translate = i18next.t;

const t = (
  key: I18nResources,
  // @TODO need to be fixed to handle parameters properly
  options?: Exclude<Parameters<typeof translate>[1], string>
) => {
  // i18next marks `context` as unknown while TFunction expects string | undefined.
  const translateFn = translate as (
    key: string,
    options?: Exclude<Parameters<typeof translate>[1], string>
  ) => string;

  return translateFn(key as string, options);
};

export { t };
